export default __webpack_public_path__ + "locales/es/Ldap.json?hash=f2b90dff3814632b99d25dade297bd9d";